import React from 'react';
import PropTypes from 'prop-types';
import { QuickLink, Box, Icon, IconWrapper } from '@honda-canada/design-system-react';
import themeStyles from './styles/NoticeGrid.styles';

const QuickLinkContainer = themeStyles.apply(Box, 'QuickLinksContainer');

const SupportCTA = ({
  title,
  variantName,
  href,
  ariaLabel,
  iconName,
  iconColor,
  iconSize,
  gtmEventHandler,
  testId,
  style,
  target,
}) => (
  <QuickLinkContainer data-testid={testId} onClick={gtmEventHandler}>
    <QuickLink
      icon={
        <IconWrapper size={['iconWrapper.sm', 'iconWrapper.md']}>
          <Icon name={iconName} iconColor={iconColor} iconSize={iconSize} />
        </IconWrapper>
      }
      title={title}
      variantName={variantName}
      href={href}
      ariaLabel={ariaLabel}
      {...style}
      target={target}
    />
  </QuickLinkContainer>
);

SupportCTA.defaultProps = {
  href: '#',
  ariaLabel: 'support-cta',
  iconColor: 'white',
  iconSize: 'default',
  testId: 'cy-support-cta',
};

SupportCTA.propTypes = {
  title: PropTypes.string.isRequired,
  variantName: PropTypes.string.isRequired,
  href: PropTypes.string,
  ariaLabel: PropTypes.string,
  iconName: PropTypes.string.isRequired,
  iconColor: PropTypes.string,
  iconSize: PropTypes.string,
  gtmEventHandler: PropTypes.func,
  style: PropTypes.shape({}),
  testId: PropTypes.string,
  target: PropTypes.string,
};

export default SupportCTA;
